import { useState, useRef, useEffect } from 'react';

export const useSearchSectionHeight = (dependency?: any) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const contentRef = useRef<HTMLDivElement>(null);
    const [contentHeight, setContentHeight] = useState<number>(0);

    useEffect(() => {
        if (!contentRef.current) return;

        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                setContentHeight(entry.target.scrollHeight + 5);
            }
        });

        resizeObserver.observe(contentRef.current);

        return () => {
            resizeObserver.disconnect();
        };
    }, [dependency]);

    return {
        isExpanded,
        setIsExpanded,
        contentRef,
        contentHeight
    };
};
